import React, { useState } from 'react';
import useInterval from '../../../customHooks/useInterval';

const Character = (props) => {
    const PACE = 450; // PACE refers to the foot animation speed
                      // some transitions in the scss that are modified in conjunction with this
    const [leftFootForward, setLeftFootForward] = useState(true);

    useInterval(() => {
        if (props.isMoving) {
            const newLeftFootForward = !leftFootForward;
            setLeftFootForward(newLeftFootForward);
            props.onWalkInterval(newLeftFootForward ? 'left' : 'right');
        }
    }, PACE)

    return (
        <div className={`Character`} 
            style={{
                top: props.position.y, 
                left: props.position.x, 
                transform: `rotate(${props.angle}deg)`,
                height: props.dimensions[1],
                width: props.dimensions[0]
            }}
        >
            <div className={`body`} />
            <div className={`feet ${props.isMoving && leftFootForward ? 'left-forward' : props.isMoving ? 'right-forward' : ''}`}>
                <div className={`foot left`} />
                <div className={`foot right`} />
            </div>
        </div>
    )
}

export default Character